<template>
  <vue-tel-input-vuetify
    :value="value"
    @input="$emit('input', $event)"
    :rules="rules"
    :label="label"
    :required="required"
    :outlined="outlined"
    solo
    flat
  ></vue-tel-input-vuetify>
</template>
<script>
export default {
  props: {
    value: {
      default: null,
      type: String
    },
    rules: {
      detault: () => {
        return [];
      },
      type: Array
    },
    label: {
      default: null,
      type: String
    },
    outlined: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  }
};
</script>
<style lang="scss">
.vue-tel-input-vuetify {
  align-items: baseline;
  .country-code {
    fieldset {
      border-top: 1px solid !important;
      border-right: none !important;
      border-bottom: 1px solid !important;
      border-left: 1px solid !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      border-top-left-radius: 4px !important;
      border-bottom-left-radius: 4px !important;
    }
  }
  .v-input__slot {
    margin-bottom: 8px;
    fieldset {
      border-top: 1px solid;
      border-left: none;
      border-bottom: 1px solid;
      border-right: 1px solid;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
}
</style>
